import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DirectoryService, EndUser} from '@gt-api';
import {GtNotificationService} from '@app/services/gt-notification.service';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {catchError, tap} from 'rxjs/operators';
import {checkResponse} from '@app/shared/utils/app-utils';
import {EMPTY, of} from 'rxjs';

export interface EndUserDialogData {
  endUser: EndUser;
  editMode: boolean;
}

@Component({
  selector: 'gt-end-user-editor',
  templateUrl: './end-user-editor.component.html',
  styleUrls: ['./end-user-editor.component.scss']
})
export class EndUserEditorComponent implements OnInit {
  endUser: EndUser;
  editMode = false;
  hasSuperRights = true;

  constructor(
    private dialogRef: MatDialogRef<EndUserEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: EndUserDialogData,
    private gtAuthenticationService: GtAuthenticationService,
    private gtDirectoryService: GtDirectoryService,
    private directoryService: DirectoryService,
    private notificationService: GtNotificationService
  ) {}

  ngOnInit(): void {
    if (this.dialogData) {
      this.endUser = this.dialogData.endUser;
      this.editMode = this.dialogData.editMode;
    }
    this.hasSuperRights = this.gtAuthenticationService.endUserAccessRights.super;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick() {
    this.directoryService
      .editContact1(this.endUser.organization, this.endUser.login, this.endUser)
      .pipe(
        checkResponse(),
        tap(() => {
          this.notificationService.showSuccessMessage();
          this.dialogRef.close(true);
        }),
        catchError(error => {
          this.notificationService.showErrorMessage(error);
          return of(EMPTY);
        })
      )
      .subscribe();
    console.log('updating end user', this.endUser);
  }
}
